<ng-container>
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <mat-date-range-input [formGroup]="formGroup" [rangePicker]="picker">
      <input matStartDate placeholder="From" formControlName="from" />
      <input matEndDate placeholder="To" formControlName="to" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</ng-container>
